import { Component, OnInit } from '@angular/core';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterrequestcustomerRelativeService } from 'src/app/Service/Letter/LetterrequestcustomerRelative.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LetterrequestcustomerRelativeList',
  templateUrl: './LetterrequestcustomerRelativeList.component.html',
  styleUrls: ['./LetterrequestcustomerRelativeList.component.scss']
})
export class LetterrequestcustomerRelativeListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private LetterrequestcustomerRelative_Service:LetterrequestcustomerRelativeService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
  ) { }


  DataList_LetterrequestcustomerRelative:Array<LetterRequestCustomer_List_Interface>=[]
  Data_Seleted_Record:LetterRequestCustomer_List_Interface=Empty_LetterRequestCustomer_List_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,2225).subscribe(
      data=>{
        this.ReadData_LetterrequestcustomerRelative()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

    
  }

  ReadData_LetterrequestcustomerRelative(){
    this.Procssing=true
    this.LetterrequestcustomerRelative_Service.Get(this.Token,this.Filter_title).subscribe(
      data=>{
        this.DataList_LetterrequestcustomerRelative=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

 //#region LetterrequestcustomerRelative Form


 Selected_LetterrequestcustomerRelative_Record_Switcher: string = 'List'
 Set_List_LetterrequestcustomerRelative_View() {
   this.ReadData_LetterrequestcustomerRelative()
   this.Selected_LetterrequestcustomerRelative_Record_Switcher= 'List'
 }

 Set_Form_LetterrequestcustomerRelative_View(item:LetterRequestCustomer_List_Interface,Switcher:string) {
   this.Data_Seleted_Record = item

   this.Selected_LetterrequestcustomerRelative_Record_Switcher = Switcher
 }

 //#endregion




}
